// import FormInput from "../../input";

import { useTranslation } from "react-i18next";
import { GetIcon } from "../../../icons";
import { RowContainer } from "../../styles/containers/styles";
import { GetValue } from "../list/functions";
import { Header, Page } from "../list/manage/styles";
import { Overlay } from "../message/styles";
import { CloseButton } from "./styles";
import { Footer } from "../list/create/styles";
import FormInput from "../input";

const PopupView = ({ themeColors, closeModal, itemTitle, popupData, customClass, openData, menu = null, actionButton,actionFunction, actionButtonName }) => {
  const [t] = useTranslation();
  const titleValue = typeof itemTitle === "string" ? itemTitle : itemTitle.collection ? openData?.data?.[itemTitle.collection]?.[itemTitle.name] : openData?.data?.[itemTitle.name];
  return (
    <Overlay className={`${customClass ?? "medium"}`}>
      <Page className={`${customClass ?? "medium"} popup-child`}>
        <Header>
          <span>
            {menu && (
              <>
                <GetIcon icon={menu.icon}></GetIcon> <span> {t(menu.label)}</span> <GetIcon icon={'next'}></GetIcon> 
              </>
            )}

            {`${t(GetValue({ type: "text" }, titleValue))}`}
          </span>
          <CloseButton theme={themeColors} onClick={closeModal}>
            <GetIcon icon={"Close"} />
          </CloseButton>
        </Header>
        <RowContainer theme={themeColors} className="popup-data">
          {popupData}
        </RowContainer>
        {actionButton && <Footer>
          <FormInput type="submit" name="submit" value={actionButtonName ? t(actionButtonName) : (openData ? (openData.data?.userApplicationStatus ? t("withdraw") : t("apply")) : t("submit"))} onChange={actionFunction} />
          <FormInput type="close" value={t("cancel")} onChange={closeModal} />
        </Footer>}
      </Page>
    </Overlay>
  );
};
export default PopupView;
